import React, { useState } from "react";
import { useSettings } from "hooks/useStore";
import Link from "components/link";
import { DropdownContent, DropdownTrigger } from "./dropdown";
import clsx from "clsx/lite";

const DROPDOWN_TYPES = new Set(["megaMenu", "groupDirectLinks"]);

const DirectLink = ({ link, onClick, index }) => (
	<Link to={link.url} onClick={onClick}
		className={clsx("desktop-header-menu-item mx-auto", index === 0 && "underline underline-offset-4 decoration-1")}>
		{link.title}
	</Link>
);

const DesktopHeaderData = ({ data, setIsMenuOpen }) => {
	const { isSearchOpen, toggleSearch } = useSettings(["isSearchOpen", "toggleSearch"]);
	const [activeMenu, setActiveMenu] = useState(null);
	if (!data?.menuItems?.length) return null;

	const isMegaMenuOpen = activeMenu?._type === "megaMenu";

	const handleOpenMenu = (link, { forceCloseSearch = false } = {}) => {
		if (isSearchOpen && !forceCloseSearch) return;
		if (isSearchOpen) toggleSearch(false);

		if (DROPDOWN_TYPES.has(link._type)) {
			setActiveMenu(link);
			setIsMenuOpen(true);
		}
	};

	const closeMenu = () => {
		if (isSearchOpen) return;
		setActiveMenu(null);
		setIsMenuOpen(false);
	};

	return (
		<div className="size-full" onMouseLeave={closeMenu}>
			<div className="desktop-header-data">
				{data.menuItems?.map((link, index) => {
					const { _type, _key } = link || {};
					const isGroupLinksOpen = activeMenu?._type === "groupDirectLinks" && activeMenu._key === _key;
					const isOpen = activeMenu?._key === _key;

					if (_type === "link") {
						return <DirectLink key={_key} index={index}
							link={link} onClick={() => handleOpenMenu(link, { forceCloseSearch: true })} />;
					}

					if (DROPDOWN_TYPES.has(_type)) {
						return (
							<div key={_key} className="relative m-auto">
								<DropdownTrigger link={link} isOpen={isOpen} handleOpenMenu={handleOpenMenu} />
								<DropdownContent isOpen={isGroupLinksOpen} position="-left-14 top-[52px] min-w-48" data={activeMenu} />
							</div>
						);
					}

					return null;
				})}
			</div>
			<DropdownContent isOpen={isMegaMenuOpen} position="left-0" data={activeMenu} />
		</div>
	);
};

export default DesktopHeaderData;